/* eslint-disable react/jsx-one-expression-per-line */
import React from "react";
import { Container, Grid, Typography } from "@mui/material";
import Logo from '~/components/Logo';
import { useLang } from "~/hooks/useLang";
import useUserState from "~/features/User/stores/UserState";
import dayjs from "dayjs";
import type { IFormBuilder } from "../../interfaces/IDispatchFormBuilder";
import type IDispatch from "../../interfaces/IDispatch";

interface HeaderPrintFormProps { 
  readonly formInfos: IFormBuilder;
  readonly dispatchInfo: IDispatch;
}

export default function HeaderPrintForm({ formInfos, dispatchInfo }: HeaderPrintFormProps) {
  const { translate } = useLang();
  const { user } = useUserState();
  const generateDocument = new Date();


  return (
    <Container fixed={false}>
      <Grid container xs={12}>
        <Grid item xs={3} justifyContent="center" alignContent="center">
          <Grid container xs={12}>
            <Grid item xs={12} maxHeight={'95px'} maxWidth={'95px'}>
              <Logo />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <b>
              {translate(formInfos.name ?? '')}
            </b>
          </Typography>
          <br />
          {formInfos.description && (
            <Typography variant="subtitle2">
              <b>
                {translate(formInfos.description)}
              </b>
            </Typography>
          )}
          <Typography variant="caption">
            {translate('Dispatch code')}: <b>{dispatchInfo.code ?? `* ${translate('Uninformed')} *`}</b>
          </Typography><br />
          <Typography variant="caption">
            {translate('Type')}: <b>{`[${dispatchInfo.type.code}] ${dispatchInfo.type.name ?? `* ${translate('Uninformed')} *`}`}</b>
          </Typography><br />
          {dispatchInfo.subtype.name && (
            <Typography variant="caption">
              {translate('Subtype')}: <b>{`[${dispatchInfo.subtype.code}] ${dispatchInfo.subtype.name ?? `* ${translate('Uninformed')} *`}`}</b>
            </Typography>
          )}
        </Grid>
        <Grid item xs={3} textAlign={'right'}>
          <Typography variant="caption" gutterBottom>
            {translate('Document generated in')}
          </Typography>
          <br />
          <Typography variant="caption">
            {dayjs(generateDocument).format('DD/MM/YYYY HH:mm:ss')}
          </Typography>
          <br />
          <Typography variant="caption">
            {translate('User')}
            :
            {user()?.representation_name?.get()}
          </Typography>
          <br />
          <Typography variant="caption">
            {translate('CPF')}
            :
            {user()?.cpf?.get()}
          </Typography>
          <br />
        </Grid>
      </Grid>
    </Container>
  )
}